import Homepage from "./componets/screens/Homepage";

function App() {
  return (
  <Homepage />
  );
}

export default App;
